/* eslint-disable */
import { CONFIG } from "~/config";

const URL = "/traffic-feedback";

interface IFeedBackResponse {
	data: string,
	error?: string,
	request: XMLHttpRequest,
	status: number,
}

export function saveFeedback(json: object = {}): {
	promise: Promise<IFeedBackResponse>,
	request: any,
} {
	return Mapy.Util.request(CONFIG.requestUrl + URL + '/saveFeedback', {
		json
	});
};
